import * as api from "../../helpers/api_helper";
import * as qs from "qs";

import { GET_ALL} from "./url";
export const getAll = (filter) => api.get(GET_ALL,{
    params: {...filter},
    paramsSerializer: params => {
      return qs.stringify(params)
    }
});